let orderSaleStatus = [
  {
    id: 1,
    name: '待确认',
    value: 'CONFIRM'
  },
  {
    id: 2,
    name: '未使用',
    value: 'NOT_USED'
  },
  {
    id: 3,
    name: '已使用',
    value: 'USED'
  },
  {
    id: 4,
    name: '过期',
    value: 'OVERDUE'
  }
]

let courtSaleStatus = [
  {
    id: 1,
    name: '待确认',
    value: 'CONFIRM'
  },
  {
    id: 2,
    name: '待出行',
    value: 'TRAVEL'
  },
  {
    id: 3,
    name: '已取消',
    value: 'CANCEL'
  },
  {
    id: 4,
    name: '已完成',
    value: 'END'
  }
]

let articleAttribute = [
  {
    id: 1,
    label: '普通文章',
    value: 'ORDINARY'
  },
  {
    id: 2,
    label: '相关推荐',
    value: 'RELEVANT'
  },
  {
    id: 3,
    label: 'VIP',
    value: 'VIP'
  },
  {
    id: 4,
    label: '比赛合集',
    value: 'RACE_NEWS'
  }
]

let goodsSaleStatus = [
  {
    id: 1,
    name: '待确认',
    value: 'CONFIRM'
  },
  {
    id: 2,
    name: '待支付',
    value: 'WAIT_PAY'
  },
  {
    id: 3,
    name: '已取消',
    value: 'CANCEL'
  },
  {
    id: 4,
    name: '已完成',
    value: 'END'
  }
]


let raceSaleStatus = [
  {
    id: 1,
    name: '待确认',
    value: 'CONFIRM'
  },
  {
    id: 2,
    name: '待出行',
    value: 'TRAVEL'
  },
  {
    id: 3,
    name: '已取消',
    value: 'CANCEL'
  },
  {
    id: 4,
    name: '已完成',
    value: 'END'
  }
]
let raceRaiseStatus = [
  {
    id: 1,
    name: '待审核',
    value: 'WAIT_APPROVAL'
  },
  {
    id: 2,
    name: '审核通过',
    value: 'APPROVED'
  },
  {
    id: 3,
    name: '审核拒绝',
    value: 'REJECT'
  }
]

let raceGameStatus = [
  {
    id: 1,
    name: '待确认',
    value: 'CONFIRM'
  },
  {
    id: 3,
    name: '已取消',
    value: 'CANCEL'
  },
  {
    id: 4,
    name: '已完成',
    value: 'END'
  }
]

let enumEnable = [
  { id: 1, name: '启用', value: 'NORMAL' },
  { id: 2, name: '禁用', value: 'DISABLE' }
]

let payYesNo = [
  { id: 1, name: '是', value: 'YES' },
  { id: 2, name: '否', value: 'NO' }
]
/**
 * 广告
 * */
let ADVERTISE = [
  { id: 1, name: '图片广告', value: 'PICTURE' },
  { id: 2, name: '视频广告', value: 'VIDEO' }
]

let raceWay = [
  { id: 1, name: '連続', value: 'OSC' },
  { id: 2, name: 'OUT、IN同時', value: 'OI' },
  { id: 3, name: 'ショットガン', value: 'MHK' }
]

let calculation = [
  { id: 1, name: 'ダブルペリア(上限36）', value: 'UL36' },
  { id: 2, name: 'ハンディ制', value: 'NUL' },
  { id: 3, name: 'ダブルペリア（上限なし）', value: 'PA' }
]

let gradeTable = [
  { id: 1, name: '大きいサイズ', value: 'MAX' },
  { id: 2, name: 'A4サイズ', value: 'A4' }
]

let raceFood = [
  { id: 1, name: 'コンペ料理希望', value: 'YES' },
  { id: 2, name: '手配不要', value: 'NO' }
]

let shuttleBus = [
  { id: 1, name: '要', value: 'YES' },
  { id: 2, name: '不要', value: 'NO' }
]

let banquet = [
  { id: 1, name: '参加', value: 'YES' },
  { id: 2, name: '不参加', value: 'NO' }
]

let searchVip = [
  { id: 'YES', name: '是', value: 'YES' },
  { id: 'NO', name: '不是', value: 'NO' },
  { id: 'ALL', name: '全部', value: 'ALL' }
]

let enumAreaLevel = [
  { name: '省', value: '1' },
  { name: '市', value: '2' },
  { name: '区/县', value: '3' },
  { name: '街/镇', value: '4' },
  { name: '社区/居委', value: '5' }
]

const enumSale = [
  { label: '球场优惠劵', value: 'COURT' },
  { label: '旅行优惠劵', value: 'TRAVEL' },
  { label: '商品优惠劵', value: 'GOODS' },
]

const enumApplicableProduct = [
  {
    id: 1,
    value: 'STADIUM',
    label: '球场'
  },
  {
    id: 2,
    value: 'GOODS',
    label: '商品'
  },
  {
    id: 3,
    value: 'ASSIGN',
    label: '指定（周边使用）'
  },
  {
    id: 4,
    value: 'ALL',
    label: '全部'
  }
]

const enumApplicableTarget = [
  {
    id: 1,
    value: 'ORDINARY',
    label: '普通用户'
  },
  {
    id: 2,
    value: 'VIP',
    label: 'VIP用户'
  },
  {
    id: 3,
    value: 'ALL',
    label: '全部用户'
  }
]

const enumTypes = [
  {
    id: 0,
    value: 'ACTIVATED',
    label: '未激活'
  },
  {
    id: 1,
    value: 'UNCLAIMED',
    label: '未领取'
  },
  {
    id: 2,
    value: 'CLAIMED',
    label: '待使用'
  },
  {
    id: 3,
    value: 'END',
    label: '已使用'
  },
  {
    id: 4,
    value: 'FAILURE',
    label: '已失效'
  },
  {
    id: 5,
    value: '',
    label: '全部'
  }
]

const enumStatus = [
  { key: 'STADIUM', value: '球场预定' },
  { key: 'GOODS', value: '商品' },
  { key: 'ASSIGN', value: '指定（周边使用）' },
  { key: 'ALL', value: '全部' },
  { key: 'ORDINARY', value: '普通会员' },
  { key: 'VIP', value: 'vip会员' },
  { key: 'DAY', value: '发放记天类型' },
  { key: 'TIME', value: '固定时间段类型' },
  { key: 'ACTIVATED', value: '未激活' },
  { key: 'UNCLAIMED', value: '未领取' },
  { key: 'CLAIMED', value: '待使用' },
  { key: 'END', value: '已使用' },
  { key: 'FAILURE', value: '已失效' },
  { key: 'WESTERNFOOD', value: '西餐' },
  { key: 'HOTPOT', value: '火锅' },
  { key: 'CHINESEFOOD', value: '中餐' },
  { key: 'JAPANESECUISINE', value: '日料' },
  { key: 'BARBECUE', value: '烤肉' },
  { key: 'SETMEALDRINKFREE', value: '套餐&畅饮' },
  { key: 'SECONDMEETINGBAR', value: '二次会·酒吧' },
  { key: 'OTHER', value: '其他' },
]

const restaurantCouponBuyType = [
  {
    id: 1,
    value: 'RMB',
    label: '现金'
  },
  {
    id: 2,
    value: 'INTEGRAL',
    label: '积分'
  },
]

export {
  enumAreaLevel,
  searchVip,
  ADVERTISE,
  shuttleBus,
  raceFood,
  calculation,
  gradeTable,
  raceWay,
  orderSaleStatus,
  raceRaiseStatus,
  banquet,
  enumEnable,
  courtSaleStatus,
  goodsSaleStatus,
  payYesNo,
  articleAttribute,
  raceSaleStatus,
  raceGameStatus,
  enumSale,
  enumStatus,
  enumApplicableProduct,
  enumApplicableTarget,
  enumTypes,
  restaurantCouponBuyType
}
